if (!customElements.get('products-bought-together-single-cart')) {
  class ProductsBoughtTogetherSingleCart extends HTMLElement {
    connectedCallback() {
      this.mainForm = this.findMainProductForm();

      if (!this.mainForm) {
        console.warn('[Bought together] Main product form was not found.');
        return;
      }

      this.handleFormData = this.handleFormData.bind(this);
      this.mainForm.addEventListener('formdata', this.handleFormData);
    }

    disconnectedCallback() {
      if (this.mainForm) {
        this.mainForm.removeEventListener('formdata', this.handleFormData);
      }
    }

    findMainProductForm() {
      const configuredId = this.dataset.mainProductFormId;

      if (configuredId) {
        return document.getElementById(configuredId);
      }

      return (
        document.querySelector('form[id^="BuyButtons-ProductForm-"][action*="/cart/add"]') ||
        document.querySelector('product-form-component form.shopify-product-form[action*="/cart/add"]')
      );
    }

    getPersonalizationProperties(formData) {
      const properties = [];

      for (const [key, value] of formData.entries()) {
        const match = key.match(/^properties\[(.+)\]$/);
        if (!match) continue;
        if (value === '') continue;

        properties.push({ key, name: match[1], value });
      }

      return properties;
    }

    handleFormData(event) {
      const formData = event.formData;
      const mainVariantId = formData.get('id');

      if (!mainVariantId) return;

      const mainQuantity = formData.get('quantity') || '1';
      const mainSellingPlan = formData.get('selling_plan');
      const properties = this.getPersonalizationProperties(formData);
      const selectedCards = this.querySelectorAll(
        '.product-bought-together__checkbox:checked'
      );

      if (selectedCards.length === 0) return;

      // Pebble submits the product form with FormData. Convert the normal single-item
      // fields into Shopify's documented multi-item `items[index]` payload just before
      // that FormData is sent to /cart/add.js.
      formData.delete('id');
      formData.delete('quantity');
      formData.delete('selling_plan');
      properties.forEach(({ key }) => formData.delete(key));

      formData.append('items[0][id]', mainVariantId);
      formData.append('items[0][quantity]', mainQuantity);

      if (mainSellingPlan) {
        formData.append('items[0][selling_plan]', mainSellingPlan);
      }

      properties.forEach(({ name, value }) => {
        formData.append(`items[0][properties][${name}]`, value);
      });

      let itemIndex = 1;

      selectedCards.forEach((checkbox) => {
        const card = checkbox.closest('.product-card--bought-together');
        const cardForm = card?.querySelector('.product-card__form');
        const variantId = cardForm?.querySelector('[name="id"]')?.value;
        const quantity = cardForm?.querySelector('[name="quantity"]')?.value || '1';

        if (!variantId) return;

        const prefix = `items[${itemIndex}]`;

        formData.append(`${prefix}[id]`, variantId);
        formData.append(`${prefix}[quantity]`, quantity);

        properties.forEach(({ name, value }) => {
          formData.append(`${prefix}[properties][${name}]`, value);
        });

        itemIndex += 1;
      });
    }
  }

  customElements.define(
    'products-bought-together-single-cart',
    ProductsBoughtTogetherSingleCart
  );
}
